const getAssetURL = (assetUrl?: string, key?: string, _presignedUrl?: string) => {
  if (!key || !assetUrl) {
    return _presignedUrl;
  }

  const url = new URL(`/${key}`, `${assetUrl}`).href;
  return url;
}

const buildQueryString = (params: any) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      searchParams.append(key, String(value));
    }
  });

  return searchParams.toString();
};

const getUuidFromUrl = (url: string): string | null => {
  try {
    const parsedUrl = new URL(url);
    
    const segments = parsedUrl.pathname
      .split('/')
      .filter(Boolean); // removes empty strings

    return segments[segments.length - 1] ?? null;
  } catch {
    return null;
  }
};




export { getAssetURL, buildQueryString, getUuidFromUrl };